import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
import { each } from "fxjs/es";
export const _handleMouseUp = (self, event) => {
  if (!self._is_mouse_down) {
    return;
  }
  const prev_is_mouse_move = self._is_mouse_move;
  const { target } = event;
  self._is_mouse_down = false;
  self._is_mouse_move = false;
  self._mouse_down_position = {
    x: 0,
    y: 0,
  };
  self._mouse_move_position = {
    x: 0,
    y: 0,
  };
  switch (self._processing_task) {
    case BaseNS.PROCESSING_TASK.PATH_EDITING: {
      if (prev_is_mouse_move) {
        return;
      }
      if (!(target instanceof self._window.Node)) {
        return;
      }
      const target_node = target;
      each(({ view }) => {
        view.click(target_node);
      })(self._path_editor_list);
      return;
    }
    case BaseNS.PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      self._processing_task = BaseNS.PROCESSING_TASK.PATH_EDITING;
      return;
    }
    default: {
      return;
    }
  }
};
